import React from "react";
import { useBoolean } from "ahooks-v2";
import { BottomFillIcon, TopFillIcon } from "@t8891/icon";
import SplitText from "@Components/SplitText";

interface IProps {
  onSelectIndex: (index: number, name: string) => void;
  formData: any;
  toggleSelect?: any;
  dataSource: {
    selectedIndex: number;
    hotRegions: number[];
    regions: {
      id: number;
      name: string;
    }[];
    parts: {
      name: string;
      regions: number[];
    }[];
  };
}

const RegionItem = ({ formData, dataSource, onSelectIndex, toggleSelect }: IProps) => {
  const { regionName } = formData;
  const [state, { toggle }] = useBoolean(false);

  return (
    <section id='RegionItem' className='w-full relative mb-24 flex items-center'>
      <div className={`w-86 relative flex`}>
        <span className='absolute text-[#ff4333] -left-10 to-4'>*</span>
        <SplitText label='地區' width={64} cls='text-[#333] font-medium text-16 leading-18'></SplitText>：
      </div>
      <div
        className='pl-10 rounded-4 border-1 border-solid border-[#e8e8e8] relative inline-flex items-center text-14 cursor-pointer flex-1 h-32 leading-32 bg-white'
        data-value={regionName}
        style={{ color: regionName === "請選擇地區" ? "#bbb" : "#333" }}
        onClick={() => {
          if (Object.keys(dataSource).length !== 0) {
            toggle();
          } else {
            toggleSelect(true);
          }
        }}
      >
        {regionName}
        <div className='absolute right-4 flex flex-col item-center'>
          {state ? <TopFillIcon size={22} /> : <BottomFillIcon size={22} />}
        </div>
      </div>
      {state && Object.keys(dataSource).length !== 0 && (
        <section
          className='w-500 bg-[#fff] rounded-4 border-solid border-[#e8e8e8] text-[#333] text-14 pt-20 px-18 top-30 left-86  absolute'
          style={{ boxShadow: "0px 8px 20px 0px rgba(0, 0, 0, 0.1)", zIndex: 1 }}
        >
          {dataSource.parts?.map((v, i: number) => (
            <div className='mb-20' key={i}>
              <label className='inline-block font-black'>{v.name}</label>
              <ul className='inline-block font-normal text-[#999] cursor-pointer hover:text-[#3264ff]'>
                {Array.isArray(v.regions) &&
                  v.regions.map((vv: any, ii: number) => (
                    <li
                      className={`inline-block font-normal ${
                        regionName === dataSource.regions[vv].name ? "text-[#3264ff]" : "text-[#999] "
                      } ml-20 cursor-pointer hover:text-[#3264ff]`}
                      key={ii}
                      onClick={() => {
                        onSelectIndex(vv, dataSource.regions[vv].name);
                        toggle();
                      }}
                    >
                      {dataSource.regions[vv].name}
                    </li>
                  ))}
              </ul>
            </div>
          ))}
        </section>
      )}
    </section>
  );
};

export default RegionItem;
